import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class channelDeptState extends baseState {
	// 渠道列表
	@observable channelDept = {};
	@action
	setChannelDept = data => this.channelDept = data;
	getChannelDept = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.CHANNEL.LIST,
			method: 'get',
			setState: this.setChannelDept,
			data
		});
	};
	// 新建
	insert = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.CHANNEL.CREATE,
			data,
		});
	};
	// 编辑
	update = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.CHANNEL.UPDATE,
			data,
		});
	};
	// 删除
	delete = id => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.CHANNEL.DELETE + id,
			data: { id }
		});
	};

	// 平台列表
	@observable platform = {};
	@action
	setPlatform = data => this.platform = data;
	getPlatform = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.PLAT.PLAT_LIST,
			method: 'get',
			setState: this.setPlatform,
			data
		});
	};

	// 平台新建
	insertPlat = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.PLAT.PLAT_ADD,
			data,
		});
	};
	// 平台编辑
	updatePlat = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.PLAT.PLAT_UPDATE,
			data,
		});
	};
	// 平台删除
	deletePlat = id => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.PLAT.PLAT_DEL + id,
			data: { id }
		});
	};
	// 平台批量解绑/绑定设备
	setPlatBindOrNot = data => this.fetch({ url: apiUrl.CHANNEL_DEPT.PLAT.PLAT_BIND_OR_NOT, method: 'post', data });

	// 平台批量推送开关
	setPlatPushOrNot = data => this.fetch({ url: apiUrl.CHANNEL_DEPT.PLAT.PLAT_PUSH_OR_NOT, method: 'post', data });

	// 平台关联设备列表
	@observable platDeviceList = {};
	@action
	setPlatDevice = data => this.platDeviceList = data;
	getPlatDevice = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.PLAT.PLAT_RELATED_DEVICE,
			method: 'get',
			setState: this.setPlatDevice,
			data
		});
	};

	@observable deviceWatchList = {};
	getDeviceWatch = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.CHANNEL.DEVICEWATCH_LIST,
			method: 'get',
			setState: (data) => this.deviceWatchList = data,
			data
		});
	};

	@observable channelEquipmentList = {};
	getEquipmentList = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.CHANNEL.DEVICEWATCH_DEPTDEVICE,
			method: 'get',
			setState: (data) => this.channelEquipmentList = data,
			data
		});
	};

	batchBindDevice = data => {
		return this.fetch({
			url: apiUrl.CHANNEL_DEPT.CHANNEL.BATCHBINDDEVICE,
			data
		});
	};
}
